import(/* webpackMode: "eager" */ "/codebuild/output/src2268905084/src/src/app/category/[query]/page.tsx");
